<template>
  <div>
    <textarea
      ref="arx"
      :name="name"
      :placeholder="placeholder"
      v-model="modelValue"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    placeholder: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    config: {
      default: {},
      type: Object
    }
  },
  data() {
    return { modelValue: (this.value || "").replaceAll("div", "p"), arx: null };
  },
  watch: {
    value() {
      // console.log("got changed");
      this.modelValue = this.value || "";
      this.modelValue = this.modelValue.replaceAll("div", "p");
      if (this.arx && this.arx.setContent) {
        this.arx.setContent({
          html: this.modelValue
        });
      }
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.destroy();
  },
  methods: {
    init() {
      this.modelValue = this.value || "";
      this.modelValue = this.modelValue.replaceAll("div", "p");
      var me = this;
      var subscribe = {
        "editor.change": function(event) {
          var html = event.get("html");
          me.handleInput(html);
          return html;
        }
      };

      // extend config
      if (typeof this.config.subscribe === "undefined") {
        this.config.subscribe = subscribe;
      } else {
        this.config.subscribe["editor.change"] = subscribe["editor.change"];
      }

      // call Article Editor
      var app = ArticleEditor(this.$refs.arx, {
        ...this.config,
        path: false
      });

      // var $toolbar = app.toolbar.getElement();
      // console.log('$toolbar', $toolbar, app.toolbar)
      // var $nodes = $toolbar.find('a');
      // console.log('$nodes', $nodes)
      // set instance
      this.arx = app;
      this.$parent.arx = app;
    },
    destroy() {
      // Call destroy on redactor to cleanup event handlers
      ArticleEditor(this.$refs.arx, "destroy");

      // unset instance for garbage collection
      this.arx = null;
      this.$parent.arx = null;
    },
    handleInput(val) {
      this.modelValue = val;
      console.log("editor changed", val);
      this.$emit("input", val);
    }
  }
};
</script>
